export default __webpack_public_path__ + "static/media/Savant's Cowl of the Eternal Eclipse.9a6416ca.jpg";